import { render, staticRenderFns } from "./ControlTile.vue?vue&type=template&id=5fff899a&"
import script from "./ControlTile.vue?vue&type=script&lang=js&"
export * from "./ControlTile.vue?vue&type=script&lang=js&"
import style0 from "./ControlTile.vue?vue&type=style&index=0&id=5fff899a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports